import { createSignal } from 'solid-js';

export const [documentTemplateTitle, setDocumentTemplateTitle] = createSignal<string | undefined>();
